enum PlaySessionEventTypes {
  CHALLENGE_ACCEPTED = "challenge_accepted",
}

export default PlaySessionEventTypes;
